import { graphql } from "gatsby";
import React from "react";

import Stat from "../components/Stat";

const StatParagraph = ({ content }) => {
  return (
    <>
      <Stat
        pretext={content.pretext}
        number={content.number}
        posttext={content.posttext}
      />
      <div
        className="m0-children line1-children"
        dangerouslySetInnerHTML={{
          __html: content.description.processed,
        }}
      />
    </>
  );
};

export const query = graphql`
  fragment ParagraphStat on paragraph__stat {
    __typename
    id
    number: field_stat_number
    posttext: field_stat_posttext
    pretext: field_stat_pretext
    description: field_stat_description {
      processed
    }
  }
`;

export default StatParagraph;
